/**
 * API Key 服务
 */
import { api } from './authService';

export interface ApiKey {
  id?: number;
  api_key_id: string;
  tenant_code: string;
  name: string;
  description?: string;
  is_active: boolean;
  expires_at?: string;
  last_used_at?: string;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
}

export interface CreateApiKeyRequest {
  tenant_code: string;
  name: string;
  description?: string;
  expires_at?: string;
}

export interface CreateApiKeyResponse {
  api_key: string; // 只在创建时返回一次
  api_key_id: string;
  name: string;
  created_at: string;
  expires_at?: string;
}

export interface UpdateApiKeyRequest {
  name?: string;
  description?: string;
  is_active?: boolean;
  expires_at?: string;
}

export interface ApiKeyFilters {
  is_active?: boolean;
  name?: string;
}

class ApiKeyService {
  /**
   * 创建 API Key
   */
  async createApiKey(request: CreateApiKeyRequest): Promise<CreateApiKeyResponse> {
    const response = await api.post<{ success: boolean; data: CreateApiKeyResponse }>(
      '/agent/workflow/api-keys',
      request
    );
    return response.data.data;
  }

  /**
   * 获取 API Key 列表
   */
  async getApiKeys(tenantCode: string, filters?: ApiKeyFilters): Promise<ApiKey[]> {
    const params: any = { tenant_code: tenantCode };
    if (filters?.is_active !== undefined) {
      params.is_active = filters.is_active;
    }
    if (filters?.name) {
      params.name = filters.name;
    }

    const response = await api.get<{ success: boolean; data: ApiKey[] }>(
      '/agent/workflow/api-keys',
      { params }
    );
    return response.data.data;
  }

  /**
   * 获取 API Key 详情
   */
  async getApiKey(apiKeyId: string): Promise<ApiKey> {
    const response = await api.get<{ success: boolean; data: ApiKey }>(
      `/agent/workflow/api-keys/${apiKeyId}`
    );
    return response.data.data;
  }

  /**
   * 更新 API Key
   */
  async updateApiKey(apiKeyId: string, updates: UpdateApiKeyRequest): Promise<void> {
    await api.put(`/agent/workflow/api-keys/${apiKeyId}`, updates);
  }

  /**
   * 删除 API Key
   */
  async deleteApiKey(apiKeyId: string): Promise<void> {
    await api.delete(`/agent/workflow/api-keys/${apiKeyId}`);
  }
}

export const apiKeyService = new ApiKeyService();

